import React, { useState } from "react";
import { MODIFY_ORDER_TYPE_PROMOTION, PRIMARY } from "../../../constants";
import { Button } from "@dishopsaas/design-system";
import { changeOrderType } from "../OrderStatus.services";
import { Typography, Box } from "@mui/material";
import getStyles from "../OrderStatus.styles";
type OrderStatusEmergencyDeliveryProps = {
  order: any;
  isLoading: boolean;
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
  isDeliveryEmergency: boolean;
  reductionToClickAndCollect: number;
};

export default function OrderStatusEmergencyDelivery({
  reductionToClickAndCollect,
  isDeliveryEmergency,
  order,
  isLoading,
  setIsLoading,
}: OrderStatusEmergencyDeliveryProps) {
  const [loadingChangingOrderType, setLoadingChangingOrderType] =
    useState(false);
  if (!isDeliveryEmergency) {
    return null;
  }
  const styles = getStyles()
  return (
    <Box sx={styles.emergency}>
      <Box>
        <Typography variant='body2' sx={{ fontWeight: 620 }}>Vous ne souhaitez pas attendre plus longtemps ?</Typography>
        <Typography variant="caption" >Récupérez votre commande auprès du restaurant et économisez {reductionToClickAndCollect}€
        </Typography>
      </Box>
      <Button
        colorType={PRIMARY}
        disabled={isLoading}
        isLoading={loadingChangingOrderType}
        onClick={async () =>
          await changeOrderType(
            setIsLoading,
            order,
            MODIFY_ORDER_TYPE_PROMOTION.CLICK_AND_COLLECT,
            setLoadingChangingOrderType
          )
        }
        label={`Je me déplace et j'économise ${reductionToClickAndCollect}€`}
        width='100%'
      />
    </Box>

  );
}
